import { useState } from "react";
import { COLOR_DARK, COLOR_HIGHLIGHTED, COLOR_MEDIUMDARK } from "../defaults";
import info_icon from "../images/info.png";
import { answerNo, answerYes, NameOfTheGame, NewGamePopupConfirmation1, NewGamePopupConfirmation2, NewGamePopupContinueGame, NewGamePopupNewGame, SubtitleOfTheGame } from "../strings";

/**
 * Confirmation screen that pops up if a save is available and one clicks 'New Game'.
 * @returns 
 */
const NewGameConfirmation = ({
  handleCloseNewGame,
  showConfirmation,
  setShowConfirmation
}) => {

  const confirmNewGame = () => {
    setShowConfirmation(false);
    handleCloseNewGame();
  };

  const hideConfirmation = () => {
    setShowConfirmation(false);
  };

  return (
    <div className="new-game-confirmation-popup-wrapper" style={{display: showConfirmation ? "flex" : "none"}}>
      <div className="new-game-confirmation-popup">
        {NewGamePopupConfirmation1}<br></br>{NewGamePopupConfirmation2}
        <div style={{display: "flex", flexDirection: "row", columnGap: "10dvh", marginTop: "10dvh"}}>
          <button
          className="new-game-confirmation-button"
          onClick={confirmNewGame}>
            {answerYes}
          </button>
          <button
          className="new-game-confirmation-button"
          onClick={hideConfirmation}>
            {answerNo}
          </button>
        </div>
      </div>
    </div>
  );
};

const NewGamePopup = ({
  handleCloseContinue,
  handleCloseNewGame,
  displayInfoModal,
  show,
  noSaveAvailable,
}) => {

  const [showConfirmation, setShowConfirmation] = useState(false);

  const popupmain = {
    backgroundColor: COLOR_MEDIUMDARK,
    width: "90%",
    height: "90%",
    border: "1dvh solid rgba(255, 255, 255, 0.15)",
    borderRadius: "0.5em",
    boxSizing: "border-box"
  };

  const popup = {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    backgroundColor: COLOR_DARK,
    justifyContent: "center",
    alignItems: "center",
    display: show ? "flex" : "none",
    zIndex: "8",
  };

  /**
   * If a save is available, render confirmation screen.
   */
  const handleNewGame = () => {
    noSaveAvailable ? handleCloseNewGame() : setShowConfirmation(true);
  }

  const handleContinue = () => {
    handleCloseContinue();
  }

  return (
    <div style={popup}>
      <button 
        onClick={displayInfoModal}
        className="info-button"
      >
        <img src={info_icon} style={{width: "2.5dvh", height: "2.5dvh"}}/>
      </button>
      <section className="popup-main" style={popupmain}>
        <div className="new-game-popup-title">
          <svg viewBox="0 0 1600 400" width="100%" height="40%">
            <path
              id="curve_title"
              d="M 0,400 Q 800,250 1600,400"
              fill="none"
            />
            <text fill={COLOR_HIGHLIGHTED}>
              <textPath href="#curve_title" startOffset="50%" textAnchor="middle">
                {NameOfTheGame}
              </textPath>
            </text>
          </svg>
        </div>
        <div className="new-game-popup-subtitle">
          <svg viewBox="0 0 400 100" width="100%" height="10%">
            <path
              id="curve_subtitle"
              d="M 0,100 Q 200,62.5 400,100"
              fill="none"
            />
            <text fill={COLOR_HIGHLIGHTED}>
              <textPath href="#curve_subtitle" startOffset="50%" textAnchor="middle">
                {SubtitleOfTheGame}
              </textPath>
            </text>
          </svg>
        </div>
        <button
          onClick={handleNewGame}
          style={{position: "absolute", bottom: "30%", left: "50%", transform: "translateX(-50%)"}}
          className="new-game-popup-button"
        >
          {NewGamePopupNewGame}
        </button>
        <div></div>
        <br></br>
        <button
          onClick={handleContinue}
          style={{position: "absolute", bottom: "15%", left: "50%", transform: "translateX(-50%)"}}
          className="new-game-popup-button"
          disabled={noSaveAvailable}
        >
          {NewGamePopupContinueGame}
        </button>
      </section>
      <NewGameConfirmation handleCloseNewGame={handleCloseNewGame} showConfirmation={showConfirmation} setShowConfirmation={setShowConfirmation}/>
    </div>
  );
};

export default NewGamePopup;
